module.exports = __webpack_public_path__ + "static/img/DZ.7682fcef.svg";